<div>
  <app-newheroheader [pageData]="pageData"></app-newheroheader>
  @defer {
    <!-- <app-trusted-way-section [pageData]="pageData"></app-trusted-way-section> -->
    <!-- <app-unified-solutions [pageData]="pageData"></app-unified-solutions> -->
    <!-- <app-gateway [pageData]="pageData"></app-gateway> -->
    <!-- <app-financial-solutions [pageData]="pageData"></app-financial-solutions> -->

    <!-- <app-common-borderless [borderlessData]="borderlessData"></app-common-borderless> -->
    <!-- <app-regulated [pageData]="pageData"></app-regulated> -->
    <!-- <app-trusted-by [pageData]="pageData"></app-trusted-by> -->
    <!-- <app-security [pageData]="pageData"></app-security> -->
    <!-- <app-discover [pageData]="pageData"></app-discover> -->
    <!-- <app-common-latest-news [blogData]="blogData"></app-common-latest-news> -->
  }
</div>
